import { render, staticRenderFns } from "./minus_another-20.vue?vue&type=template&id=eb63dbb2&scoped=true"
import script from "./minus_another-20.vue?vue&type=script&lang=js"
export * from "./minus_another-20.vue?vue&type=script&lang=js"
import style0 from "./minus_another-20.vue?vue&type=style&index=0&id=eb63dbb2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb63dbb2",
  null
  
)

export default component.exports